import $ from 'jquery';

$.fn.currency = function (options) {
    const settings = $.extend({
        serviceUrl: "/currency.php"
    }, options);

    const request = $.ajax({
        url: settings.serviceUrl,
        dataType: "json"
    });

    return this.each(function () {
        const parent = $(this);

        request.done((response) => {
            let rows = '';
            Object.keys(response).map((rowIndex) => {
                let row = response[rowIndex];
                let icon = row[3] === 'up' ? 'icon-arrow_drop_up' : 'icon-arrow_drop_down';
                rows += '<div class="flex-table--row">' +
                            `<div class="flex-table--cell">${row[0]}</div>` +
                            `<div class="flex-table--cell">${row[1]}</div>` +
                            `<div class="flex-table--cell"><i class="currency--status currency--status__${row[3]} ${icon}"></i></div>` +
                            `<div class="flex-table--cell">${row[2]}</div>` +
                        '</div>';

            });
            parent.html( `<div class="flex-table">${rows}</div>` );
        })

    });

};


export default class Currency {
    constructor(selector, options = {}) {
        $(selector).currency(options)
    }
}



// WEBPACK FOOTER //
// ./src/scripts/currency.js